module.exports = __webpack_public_path__ + "img/9791159922695.37d5feed.jpg";